export default __webpack_public_path__ + "static/do-link-dcc212da364dd49a863781c64cd6db6f.png";